<h2 mat-dialog-title> {{ 'do-you-save.please-save' | translate }}</h2>
<mat-dialog-content>
</mat-dialog-content>
<mat-dialog-actions style="display: flex; justify-content: space-between;" class="ti-form__button-panel">
  <button mat-button [mat-dialog-close]="true">{{ 'COMMON.no' | translate }}</button>
  <button mat-raised-button color="accent" [mat-dialog-close]="false">{{'COMMON.save' | translate}}</button>
</mat-dialog-actions>
